import styled from 'styled-components';

export const Buttons = styled.div`
  width: 60%;
  margin: 50px auto 20px auto;
  display: flex;
  justify-content: space-between;
`;
